import { Button, Col, Image, Row, Table } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";

import Bram2019 from "../../data/it/bramprimipassi/2020.json";
import Bram2020 from "../../data/it/bram/2020.json";
import Bram2021 from "../../data/it/bram/2021.json";
import Brichet2021 from "../../data/it/brichet/2021.json";
import Brichet2022 from "../../data/it/brichet/2022.json";
import BrichetOld from "../../data/it/brichet/1984-1995.json";
import React from "react";
import Sialic2019 from "../../data/it/sialicesperienzadibotte/2020.json";
import Sialic2020 from "../../data/it/sialic/2020.json";
import Sialic2021 from "../../data/it/sialic/2021.json";
import Sialic2022 from "../../data/it/sialicespressionidibucce/2022.json";
import SialicOld from "../../data/it/sialic/2018-2019.json";
import Tan2020 from "../../data/it/tan/2020.json";

const WineChapter = ({ title, text }) => {
	return (
		<Row>
			<h3>{title}</h3>
			<p>
				<span dangerouslySetInnerHTML={{ __html: text }} />
			</p>
		</Row>
	);
};

export const Wine = () => {
	const Wines = {
		bramprimipassi: {
			2020: Bram2019,
		},
		bram: {
			2020: Bram2020,
			2021: Bram2021,
		},
		brichet: {
			19841995: BrichetOld,
			2021: Brichet2021,
			2022: Brichet2022,
		},
		sialicesperienzadibotte: {
			2020: Sialic2019
		},
		sialicespressionidibucce: {
			2022: Sialic2022,
		},
		sialic: {
			20182019: SialicOld,
			2020: Sialic2020,
			2021: Sialic2021,
		},
		tan: {
			2020: Tan2020
		}
	};

	let { nome, anno } = useParams();
	if (nome === null || nome === undefined || nome === "") {
		return <Navigate to={"/"} />;
	}
	if (anno === null || anno === undefined || anno === "") {
		return <Navigate to={"/vini/" + nome} />;
	}
	if (!Wines.hasOwnProperty(nome)) {
		return <Navigate to={"/vini"} />;
	}
	if (!Wines[nome].hasOwnProperty(anno)) {
		return <Navigate to={"/vini/" + nome} />;
	}
	const Wine = Wines[nome][anno];

	let kitchen = "Temperatura di servizio: " + Wine.temperature;
	if (Wine.notes !== "") {
		kitchen += "<br>Note: " + Wine.notes;
	}
	const senses =
		"Colore: " +
		Wine.color +
		"<br>Aroma: " +
		Wine.aroma +
		"<br>Gusto: " +
		Wine.flavor;
	const bottle =
		"Annata: " +
		Wine.years +
		"<br>Vitigno: " +
		Wine.grapeVariety +
		"<br>Gradazione: " +
		Wine.alcool +
		"<br>Bottiglie prodotte: " +
		Wine.numberBottles;
	return (
		<>
			<Row>
				<Col md={12} className="text-center">
					<h2>{Wine.title} {Wine.years}</h2>
				</Col>
			</Row>
			<Row>
				<Col md={5} style={{ padding: "5vh" }} className="text-center">
					<Image
						src={Wine.image}
						style={{ maxWidth: "100%", maxHeight: "85vh" }}
					/><br />
					{Wine.ecommerceLink === "" ? <span></span> : <Button style={{ marginTop: '3vh', padding: '1vh 5vh', fontSize: '1.2em', backgroundColor: 'black', color: 'white', border: '0' }} href={Wine.ecommerceLink} target="_blank">
						Acquista
					</Button>}

				</Col>
				<Col md={7} style={{ padding: "10vh" }}>
					{Wine.special !== "" ? <WineChapter title="La Storia" text={Wine.special} /> : <>
						<WineChapter title="Il Vigneto" text={Wine.vineyard} />
						<WineChapter title="La Vendemmia" text={Wine.harvest} />
						<WineChapter title="La Vinificazione" text={Wine.winemaking} />
						<WineChapter title="Il Vino" text={Wine.denomination} />
						<WineChapter title="La Bottiglia" text={bottle} />
						<WineChapter title="I Sensi" text={senses} />
						<WineChapter title="In Cucina" text={kitchen} /></>
					}
				</Col>
			</Row>
			<Row
				style={{ backgroundColor: "black" }}
				className="justify-content-center"
			>
				<Col sm={10} md={8} xl={5} style={{ padding: "5vh" }} className="text-center">
					<Table bordered style={{ color: "white" }} size="sm" responsive>
						<thead>
							<tr>
								<th scope="col" colSpan="1">
									COMPONENTE
								</th>
								<th scope="col" colSpan="1">
									CODICE
								</th>
								<th scope="col" colSpan="1">
									MATERIALE
								</th>
								<th scope="col" colSpan="1">
									SMALTIMENTO
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan="1">BOTTIGLIA</td>
								<td colSpan="1">GL 72</td>
								<td colSpan="1">VETRO</td>
								<td colSpan="1">RACCOLTA DIFFERENZIATA VETRO</td>
							</tr>
							<tr>
								<td colSpan="1">TAPPO</td>
								<td colSpan="1">FOR 51</td>
								<td colSpan="1">SUGHERO</td>
								<td colSpan="1">RACCOLTA DIFFERENZIATA DEDICATA O ORGANICO</td>
							</tr>
							<tr>
								<td colSpan="1">CAPSULA</td>
								<td colSpan="1">C/ALU 90</td>
								<td colSpan="1">POLILAMINATO</td>
								<td colSpan="1">RACCOLTA DIFFERENZIATA METALLI</td>
							</tr>
							<tr>
								<td colSpan="4">
									Verifica le disposizioni del tuo comune. Separa le componenti
									e conferiscile in modo corretto.
								</td>
							</tr>
						</tbody>
					</Table>
				</Col>
			</Row>
		</>
	);
};
